import { render } from "./OzonOffer.vue?vue&type=template&id=987bbbc2"
import script from "./OzonOffer.vue?vue&type=script&lang=js"
export * from "./OzonOffer.vue?vue&type=script&lang=js"

import "./OzonOffer.vue?vue&type=style&index=0&id=987bbbc2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__